const HOME = "/";
const CUSTOMER_STATISTIC = '/statistic/:date';
const WEEK_STATISTIC = '/week/statistic/:date';
// const LOGIN = "/login";
const CUSTOMER = "/customer";
const ADD_CUSTOMER = "/customer/add";
const UPDATE_CUSTOMER = "/customer/update";
const MEDICINE = "/medicine";
const ADD_MEDICINE = "/medicine/add";
const UPDATE_MEDICINE = "/medicine/update";
const IMPORT_MEDICINE = "/medicine/import";
const ADD_IMPORT_MEDICINE = "/medicine/addImport";
const EDIT_IMPORT_MEDICINE = "/medicine/editImport";
const BATCH_IMPORT_MEDICINE = "/medicine/batchImport";
const TREATMENT = "/customer/treatment";
const ADD_TREATMENT = "/customer/treatment/add";
const EDIT_TREATMENT = "/customer/treatment/update"
const PROCESS = "/process"
const PROCESS_TREATMENT = '/process/treatment'
const SEARCH = "/search"
const ACTIVITY_LOG = "/activity-log"

const routesMap = {
  HOME,
  CUSTOMER_STATISTIC,
  WEEK_STATISTIC,
  // LOGIN,
  CUSTOMER,
  MEDICINE,
  ADD_MEDICINE,
  TREATMENT,
  ADD_TREATMENT,
  ADD_CUSTOMER,
  UPDATE_CUSTOMER,
  UPDATE_MEDICINE,
  IMPORT_MEDICINE,
  ADD_IMPORT_MEDICINE,
  EDIT_IMPORT_MEDICINE,
  BATCH_IMPORT_MEDICINE,
  EDIT_TREATMENT,
  PROCESS,
  PROCESS_TREATMENT,
  SEARCH,
  ACTIVITY_LOG,
};

export default routesMap;
